import styled from "styled-components";

export const ServicesContainer = styled.div`
  height: auto;
  padding: 4rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  /* background: linear-gradient(0.25turn, #4c1109, #a0410f, #4c1109); */
  background: linear-gradient(
    180deg,
    rgba(45, 38, 67, 1) 100%,
    rgba(0, 0, 0, 255) 17%,
    rgba(9, 9, 121, 1) 39%
  );
  /* background: #010606; */

  @media screen and (max-width: 768px) {
    height: 2000px;
    padding-top: 10px;
    margin-top: -8rem;
  }

  @media screen and (max-width: 480px) {
    height: 1800px;
    margin-top: -8rem;
    padding-top: 10px;
  }
`;

export const ServicesWrapper = styled.div`
  /* max-width: 1000px; */
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  align-items: center;
  grid-gap: 6rem;
  padding: 0 50px;
  margin-top: 3%;
  @media screen and (max-width: 1000px) {
    grid-template-columns: 1fr 1fr;
  }

  @media screen and (max-width: 768px) {
    grid-template-columns: 1fr;
    padding: 0 20px;
  }
`;

export const ServicesCard = styled.div`
  /* background: #fff; */
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  border-radius: 10px;
  max-height: 340px;
  padding: 30px;
  width: 222px;
  /* box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2); */
  transition: all 0.2s ease-in-out;

  &:hover {
    transform: scale(1.02);
    transition: all 0.2s ease-in-out;
    cursor: pointer;
  }
`;

export const ServicesIcon = styled.img`
  height: 245px;
  width: 246px;
  border-radius: 50%;
  border: 4px solid #828;
  margin-bottom: 10px;
  /* border-radius: 15px; */
`;

export const ServicesH1 = styled.h1`
  font-size: 50px;
  color: white;
  font-family: "honeybear";
  font-weight: bold;
  margin-bottom: 0px !important;
  @media screen and (max-width: 480px) {
    font-size: 4rem;
  }
  @media screen and (max-width: 768px) {
    font-size: 28px;
    margin-top: -6rem;
  }
`;

export const ServicesH2 = styled.h2`
  font-size: 25.4px;
  font-family: "honeybear";
  color: white;
  font-weight: bold;
  line-height: 4;
  margin-bottom: 0px !important;
  @media screen and (max-width: 768px) {
    font-size: 24px;
  }
`;

export const ServicesP = styled.p`
  font-size: 20.2px;
  width: 23rem;
  font-weight: bold;
  font-family: "poppins";
  margin-top: -20px;
  text-align: center;
  color: white;
  @media screen and (max-width: 1024px) {
    width: 20rem;
  }
`;
